/**
 * Public marketing site URL (landing + enquiry form).
 * - Web: defaults to current origin + HashRouter hash.
 * - Mobile APK: set REACT_APP_PUBLIC_WEB_URL at build time (e.g. https://yourdomain.com).
 */

export function getPublicLandingUrl() {
  const explicit = (process.env.REACT_APP_PUBLIC_WEB_URL || '').trim().replace(/\/$/, '');
  if (explicit) {
    return `${explicit}/#/`;
  }
  if (typeof window !== 'undefined') {
    const { origin, pathname } = window.location;
    const basePath = pathname.endsWith('/') ? pathname : `${pathname}/`;
    return `${origin}${basePath}#/`;
  }
  return '/#/';
}

/**
 * Opens the landing URL in the device browser (native app) or a new tab (web).
 */
export async function openLandingInSystemBrowser() {
  const url = getPublicLandingUrl();
  if (typeof window === 'undefined') return;

  const isNative =
    window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function'
      ? window.Capacitor.isNativePlatform()
      : false;

  if (isNative) {
    try {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url });
      return;
    } catch (e) {
      console.warn('Capacitor Browser.open failed, falling back to window.open', e);
    }
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
